export const LOCAL_STORAGE_KEYS = {
  LOGOUT: 'logout',
  HIDE_ACCEPT_COOKIES_BANNER: 'hideAcceptCookiesBanner',
  SUBSCRIPTION_REQUIRED_SHOWN: 'subscriptionReqiredShown',
  SHOW_RETRO_SESSION_ACTIONS: 'showRetroSessionActions',
};

export enum COOKIES_KEYS {
  CURRENT_SPACE_ID = 'currSpaceId',
  ADD_TO_HOME_SCREEN_SHOWN = 'addTohomeScreenShown',
  NEXT_LOCALE = 'NEXT_LOCALE',
  SIGN_UP = 'signUp',
  LIVE_XP_ENGLISH_BANNER = 'liveXPEnglishBanner'
}

export enum DEBUG_COOKIES_KEYS {
}

export enum DATA_TEST_ID {
  TEAM_CREATE_MODAL = 'team-create-modal',
  SPACE_INVITE_MODAL = 'space-invite-modal',
  TEAM_CREATE_MODAL_CANCEL_BTN = 'team-create-modal-cancel-btn',
  TEAM_CREATE_MODAL_SUBMIT_BTN = 'team-create-modal-submit-btn',
  TEAM_ITEM = 'team-item',
  TEAM_EDIT_MODAL = 'team-edit-modal',
  TEAM_CREATE_BTN = 'team-create-btn',
  POKER_SESSION_CREATE_BTN = 'poker-session-create-btn',
  POKER_SESSION_CREATE_MODAL = 'poker-session-create-modal',
  POKER_SESSION_CREATE_MODAL_CANCEL_BTN = 'poker-session-create-modal-cancel-btn',
  POKER_SESSION_TEAMS_EDIT_MODAL = 'poker-session-teams-edit-modal',
  POKER_SESSION_TEAMS_EDIT_MODAL_CANCEL_BTN = 'poker-session-teams-edit-cancel-btn',
  POKER_SESSION_TEAMS_EDIT_MODAL_SUBMIT_BTN = 'poker-session-teams-edit-submit-btn',
  POKER_SESSION_SHARE_BTN = 'poker-session-share-btn',
  USER_AVATAR = 'user-avatar',
  RETRO_SESSION_CREATE_BTN = 'retro-session-create-btn',
  RETRO_SESSION_CREATE_MODAL = 'retro-session-create-modal',
  RETRO_SESSION_TEAMS_EDIT_MODAL_SUBMIT_BTN = 'retro-session-teams-edit-submit-btn',
  RETRO_SESSION_TEAMS_EDIT_MODAL = 'retro-session-teams-edit-modal',
  RETRO_SESSION_EDIT_MODAL = 'retro-session-edit-modal',
  RETRO_SESSION_CREATE_MODAL_CANCEL_BTN = 'retro-session-create-modal-cancel-btn',
}

export enum CLASS_TEST {
  SPACE_CREATE_BTN = 'space-create-btn',
  SPACE_CREATE_MODAL_SUBMIT_BTN = 'space-create-modal-submit-btn',
  SPACE_CREATE_USER_MENU_ITEM = 'space-create-user-menu-item',
  POKER_SESSION_CREATE_MODAL_SUBMIT_BTN = 'poker-session-modal-submit-create-btn',
  SPACE_ONBOARDING_LAST_STEP_BTN = 'space-onboarding-last-step-btn',
  POKER_SESSION_LINK_BTN = 'poker-session-link-btn',
  POKER_STORY_REMOVE_MODAL_SUBMIT_BTN = 'poker-story-remove-modal-submit-btn',
  POKER_STORY_START = 'poker-story-start',
  POKER_STORY_STOP = 'poker-story-stop',
  SIGN_UP_BTN = 'sign-up-btn',
  AUTH_GOOGLE_BTN = 'auth-google-btn',
  AUTH_APPLE_BTN = 'auth-apple-btn',
  TEAM_CREATE_MODAL_SUBMIT_BTN = 'team-create-modal-submit-btn',
  POKER_VIDEO_CALL_START_BTN = 'pokervideo-call-start-btn',
  POKER_SESSION_FEEDBACK_BTN = 'poker-session-feedback-btn',
  JIRA_CONNECT_LINK = 'jira-connect-link',
  POKER_SESSION_JIRA_IMPORT_STORIES = 'poker-session-jira-import-stories',
  RETRO_SESSION_CREATE_MODAL_SUBMIT_BTN = 'retro-session-modal-submit-create-btn',
  RETRO_SESSION_EDIT_MODAL_SUBMIT_BTN = 'retro-session-modal-submit-edit-btn',
  COOKIES_BANNER_CLOSE_BTN = 'cookies-banner-close-btn'
}

export enum POST_MESSAGE_TYPE {
  KEEPMAIL_OAUTH_CODE = 'keepmail-oauth-code',
  KEEPMAIL_OAUTH_ERROR = 'keepmail-oauth-error',
}

export const DEFAULT_LOCALE = 'en';

export enum SIGN_UP_MARKER {
  RETRO = 'retro',
  KANBAN = 'kanban',
}
